import React from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIcon } from "../../../helpers/index";

const RoundedButtonOutlined = ({
  type = "button",
  rounded = false,
  disable = false,
  onClick = () => {},
  text = null,
  icon = null,
  faIcon = null,
  faIconR = null,
  size = "medium",
  title = null,
  style = {},
  id = null,
  sx = {},
  testId = null,
  href = null,
  target = null,
  rel = null,
}) => {
  // Ícones formatados
  const _icon = getIcon(icon);
  const _faIcon = faIcon ? <FontAwesomeIcon icon={faIcon} /> : null;
  const _faIconR = faIconR ? <FontAwesomeIcon icon={faIconR} /> : null;

  //Estilizações para cada tipo de botão
  const borderRadius = rounded ? "50%" : size === "small" ? "16px" : "20px";
  const padding =
    size === "small" ? "6px 12px" : size === "large" ? "12px 24px" : "8px 16px";
  const minWidth =
    size === "small" ? "48px" : size === "large" ? "120px" : "auto";

  return (
    <Button
      href={href}
      target={target}
      rel={rel}
      variant="outlined"
      type={type}
      disabled={disable}
      onClick={onClick}
      id={id}
      title={title || text}
      data-testid={testId}
      sx={{
        borderRadius: borderRadius,
        gap: "6px",
        minWidth: minWidth,
        padding: padding,
        fontWeight: "700",
        fontSize: "1rem",
        textTransform: "uppercase",
        border: "2 px solid #662D91",
        background: "#FDFDFD",
        color: "#662D91",

        "&:hover": {
          boxShadow: "0 3px 6px rgba(0, 0, 0, 0.15)",
          background: "#e5e0e9de",
        },

        ...style,
        ...sx,
      }}
    >
      {_faIcon} {text} {_icon} {_faIconR}
    </Button>
  );
};

export default RoundedButtonOutlined;
